module.exports = __webpack_public_path__ + "static/media/6.6852a7e8.jpg";